import { render, staticRenderFns } from "./AccountTeams.vue?vue&type=template&id=7c21d4ed&scoped=true"
import script from "./AccountTeams.vue?vue&type=script&lang=js"
export * from "./AccountTeams.vue?vue&type=script&lang=js"
import style0 from "./AccountTeams.vue?vue&type=style&index=0&id=7c21d4ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c21d4ed",
  null
  
)

export default component.exports